import React from 'react';
import {
  Container, Row, Col, Tab, Nav,
} from 'react-bootstrap';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import { Template } from '../template/index';
import { CreateCollege } from './CreateCollege';
import { ListCollege } from './ListCollege';

export function Colleges () {
  const history = useHistory();
  function handleGoBack () {
    history.push('/');
  }
  return (
    <Template>
      <Container className="main-updates">
        <div className="goBack">
          <FontAwesomeIcon icon={faArrowLeft} title="Voltar" size="lg" onClick={handleGoBack} />
          <h2>Gerenciar Instituições</h2>
        </div>
        <hr />
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Row>
            <Col sm={3}>
              <Nav variant="pills" className="flex-column">
                <Nav.Item>
                  <Nav.Link eventKey="first">Instituições</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Cadastrar Instituição</Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <ListCollege />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <CreateCollege />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </Template>

  );
}
